import { api } from "./api";
import { browser, browserVersion, getPath, platform } from "../utils";

import Adjust from "@adjustcom/adjust-web-sdk";
import moment from "moment";
import { DS_FUNCTION, DS_SUBFUNCTION } from "../utils/constants/events";

const BASE_URL_TRADEMAP = getPath("/api/trademap/");

class EventService extends api {
	#dataAttributionAdjust = {};
	/**
	 * Function to get attribution from Adjust data
	 * @param {boolean} ignoreSkip
	 * @returns {Promise<Adjust.Attribution>}
	 */
	async getAttributesAdjust() {
		let attr = {};

		if (Object.keys(this.#dataAttributionAdjust).length) {
			return this.#dataAttributionAdjust;
		}

		try {
			attr = await Adjust.waitForAttribution();
		} catch (error) {
			console.error("[GET ATTRIBUTES ADJUST]", error);
		} finally {
			this.#dataAttributionAdjust = attr;
			return attr;
		}
	}

	/**
	 * @param {'NEW_REGISTER' | 'NEW_LOGIN'} subFun
	 */
	async saveDeepLink(subFun) {
		const attAdjust = await this.getAttributesAdjust();

		if (!Object.keys(attAdjust).length) {
			console.warn("[SAVE DEEP LINK WARNING] - Unable to save Adjust link");
			return;
		}

		const campaign = attAdjust.campaign || "";
		const deepLink = `${attAdjust.network} - ${attAdjust.tracker_token}`;

		const payloadSaveDeepLink = {
			requests: [
				{
					dhEvent: moment().format(),
					dsFunction: DS_FUNCTION.DEEP_LINK_ORIGIN,
					dsSubfunction: DS_SUBFUNCTION[subFun],
					dsPlatform: "WEB",
					dsParam: `idchannel:13|nmchannel:Portal|${deepLink}|${campaign}`,
					idchannel: "13",
					nmchannel: "Portal",
					deepLink,
					campaign,
					deviceInfoDTO: {
						phoneModel: "",
						deviceModel: "",
						appVersion: browserVersion,
						osName: `${platform} - ${browser}`,
					},
				},
			],
		};

		return this.post(BASE_URL_TRADEMAP, "v9/analytics/save-deep-link", payloadSaveDeepLink);
	}
}

export default new EventService();
